<template>
  <div>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
      <v-switch
        v-model="showPrevious"
        label="Show Past Appointments"
        dense
        class="mx-6 mt-6"
      ></v-switch>
      <v-spacer></v-spacer>
      <v-card outlined>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              small
              text
              v-on="on"
              @click="goToAppointmentForm()"
              ><v-icon small>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>New Appointment</span>
        </v-tooltip>
        <export-appointments></export-appointments>
        <bulk-reports-modal></bulk-reports-modal>
      </v-card>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="appointments"
      item-key="mtaAppointmentId"
      :search="search"
      :items-per-page="15"
      group-by="appointmentDateNoTime"
      dense
      @click:row="goToAppointmentForm"
      style="cursor: pointer"
      :key="appointments.length"
      class="mt-3"
    >
      <template
        v-slot:[`group.header`]="{ group, headers, toggle, isOpen, items }"
      >
        <td v-if="Boolean(group)" :colspan="headers.length">
          <v-btn @click="toggle" x-small icon :ref="group">
            <v-icon v-if="isOpen">mdi-minus</v-icon>
            <v-icon v-else>mdi-plus</v-icon>
          </v-btn>
          <span class="mx-5 font-weight-bold text-subtitle-2">
            {{ items[0].formattedAppointmentDate }}
          </span>
        </td>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip x-small :color="item.statusColor" class="white--text" label
          >{{ item.status }}
        </v-chip>
      </template>
      <template v-slot:[`item.sentConfirmation`]="{ item }">
        <v-simple-checkbox
          :value="Boolean(item.lastNotificationSentAt)"
          disabled
        ></v-simple-checkbox
      ></template>
      <template v-slot:[`item.actions`]="{ item }">
        <appointment-messages
          :appointmentId="item.mtaAppointmentId"
        ></appointment-messages>
        <view-files-modal
          :appointmentId="item.mtaAppointmentId"
        ></view-files-modal>
        <reports-modal :appointmentId="item.mtaAppointmentId"></reports-modal>
        <cancel-appointment
          v-if="item.status != 'Cancelled'"
          :appointmentId="item.mtaAppointmentId"
        ></cancel-appointment>
        <restore-appointment
          v-if="item.status == 'Cancelled'"
          :appointmentId="item.mtaAppointmentId"
        ></restore-appointment>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import ExportAppointments from "./export-appointments.vue";
import BulkReportsModal from "./bulk-reports-modal.vue";
import CancelAppointment from "./cancel-appointment.vue";
import RestoreAppointment from "./restore-appointment.vue";
import AppointmentMessages from "./appointment-messages.vue";
import ViewFilesModal from "./view-files-modal.vue";
import ReportsModal from "./reports-modal.vue";
export default {
  components: {
    ExportAppointments,
    BulkReportsModal,
    CancelAppointment,
    RestoreAppointment,
    AppointmentMessages,
    ViewFilesModal,
    ReportsModal,
  },
  data() {
    return {
      headers: [
        {
          text: "IDEP Client ID",
          value: "idepClientId",
        },
        {
          text: "Name",
          value: "fullName",
        },
        { text: "Phone Number", value: "phoneNumber" },
        {
          text: "Appointment Date",
          value: "formattedAppointmentDate",
        },
        {
          text: "Appointment Time",
          value: "formattedAppointmentTime",
        },
        { text: "Status", value: "status" },
        {
          text: "Sent Confirmation",
          value: "sentConfirmation",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
      search: "",
      showPrevious: false,
    };
  },
  async mounted() {
    this.$store.commit("uxModule/setShowLoader", true);
    await this.$store.dispatch("appointmentsModule/getAppointments");
    this.$store.commit("uxModule/setShowLoader", false);
  },
  computed: {
    appointments() {
      var appointments = this.$store.state.appointmentsModule.appointments;
      var today = new Date().setHours(0, 0, 0, 0);
      return this.showPrevious
        ? appointments
        : appointments.filter((item) => item.appointmentDateNoTime >= today);
    },
  },
  methods: {
    goToAppointmentForm(appointment) {
      if (Boolean(appointment)) {
        this.$router.push({ name: "EditAppointment", params: { appointment } });
      } else {
        this.$router.push({ name: "NewAppointment" });
      }
    },
  },
};
</script>
